module.exports = __webpack_public_path__ + "img/banner3.fff8cfd6.png";